import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as authActionCreators from "../actions/authentication";
import * as eventActionCreators from "../actions/events";
import * as studentActionCreators from "../actions/students";
import * as measurementsActionCreators from "../actions/measurements";

import Main from "./Main";

function mapStateToProps(state) {
  return {
    authentication: state.authentication,
    events: state.events,
    students: state.students,
    measurements: state.measurements
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...authActionCreators,
      ...eventActionCreators,
      ...studentActionCreators,
      ...measurementsActionCreators
    },
    dispatch
  );
}

const App = connect(mapStateToProps, mapDispatchToProps)(Main);

export default App;



// WEBPACK FOOTER //
// ./components/App.js